module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "security-content"
  }, [_vm._v("\n    At MikMak, we take every possible measure to secure our applications and data. Read below to learn more about how we approach Security within the MikMak Platform.\n  ")]), _vm._v(" "), _vm._l((_vm.securityContent), function(securityItem) {
    return _c('div', {
      staticClass: "security-block"
    }, [_c('h3', [_vm._v(_vm._s(securityItem.title))]), _vm._v(" "), _vm._l((securityItem.items), function(listItem) {
      return _c('div', {
        staticClass: "security-list-item"
      }, [_c('span', {
        staticClass: "security-list-item-span security-list-item-title"
      }, [_vm._v(_vm._s(listItem.title))]), _vm._v(" "), _c('span', {
        staticClass: "security-list-item-span security-list-item-text"
      }, _vm._l((listItem.text), function(textItem) {
        return _c('label', {
          domProps: {
            "innerHTML": _vm._s(textItem)
          }
        })
      }), 0)])
    })], 2)
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-content"
  }, [_vm._v("\n\n    Contact "), _c('b', [_vm._v("security@mikmak.tv")]), _vm._v(" with any inquiries not addressed in the content above.\n\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d78cfa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Security.vue
// module id = 467
// module chunks = 0